<template>
  <canvas id="chart"></canvas>
</template>
<script>
import Chart from "chart.js";

export default {
  name: "Chart",
  components: {
    Chart,
  },
  props: ["chart"],
  mounted() {
    const ctx = document.getElementById("chart");
    var chart = new Chart(ctx, this.chart);
    document.updateChart = () => chart.update();
  },
};
</script>

<style></style>
